var React = require('react');

let rta;
var Subitutlo = React.createClass({

    render: function () {
        if (this.props.value != undefined) {
            rta = <span className="color-azul-claro">Nº {this.props.value}</span>;
        }
        else {
            rta = "";
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <h3 className={this.props.subtitleClass}>{this.props.titulo}{rta}</h3>
                </div>
            </div>
        );
    }
});

export default Subitutlo